'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactYoutube = require('react-youtube');

var _reactYoutube2 = _interopRequireDefault(_reactYoutube);

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Copyright = require('./components/Copyright');

var _Copyright2 = _interopRequireDefault(_Copyright);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoPlayer = function VideoPlayer(_ref) {
  var hasTopMargin = _ref.hasTopMargin,
      hasBottomMargin = _ref.hasBottomMargin,
      videoId = _ref.videoId,
      copyrightText = _ref.copyrightText,
      height = _ref.height,
      width = _ref.width;
  return _react2.default.createElement(
    _Wrapper2.default,
    {
      hasTopMargin: hasTopMargin,
      hasBottomMargin: hasBottomMargin
    },
    _react2.default.createElement(_reactYoutube2.default, {
      videoId: videoId,
      opts: {
        height: height !== null ? height + 'px' : '900px',
        width: width !== null ? width + 'px' : '100%',
        playerVars: {
          rel: 0,
          showinfo: 0,
          modestbranding: 0
        }
      }
    }),
    _react2.default.createElement(
      _Copyright2.default,
      null,
      copyrightText
    )
  );
};

VideoPlayer.propTypes = {
  /** Whether or not a 30px bottom margin is applied. */
  hasBottomMargin: _propTypes2.default.bool,
  /** Whether or not a 30px top margin is applied. */
  hasTopMargin: _propTypes2.default.bool,
  /** YouTube ID of the embedded video. */
  videoId: _propTypes2.default.string.isRequired,
  /** Any associated copyright text to appear below the video. */
  copyrightText: _propTypes2.default.string,
  /** height of the embedded frame */
  height: _propTypes2.default.string,
  /** max width of the embedded frame */
  width: _propTypes2.default.string
};

VideoPlayer.defaultProps = {
  hasBottomMargin: true,
  hasTopMargin: true,
  copyrightText: '',
  height: window.innerHeight,
  width: window.innerWidth
};

VideoPlayer.displayName = 'VideoPlayer';

exports.default = VideoPlayer;
VideoPlayer.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'VideoPlayer',
  'props': {
    'hasBottomMargin': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px bottom margin is applied.'
    },
    'hasTopMargin': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px top margin is applied.'
    },
    'copyrightText': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Any associated copyright text to appear below the video.'
    },
    'height': {
      'defaultValue': {
        'value': 'window.innerHeight',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height of the embedded frame'
    },
    'width': {
      'defaultValue': {
        'value': 'window.innerWidth',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'max width of the embedded frame'
    },
    'videoId': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'YouTube ID of the embedded video.'
    }
  }
};